const thumbCache = new Map<string, string>();

export function isImageDocument(mime?: string | null, fileName?: string | null): boolean {
  if (mime?.startsWith('image/')) return true;
  const name = (fileName || '').toLowerCase();
  return /\.(jpe?g|png|gif|webp|bmp|heic|heif)$/.test(name);
}

export function isPdfDocument(mime?: string | null, fileName?: string | null): boolean {
  if (mime === 'application/pdf') return true;
  return (fileName || '').toLowerCase().endsWith('.pdf');
}

export function formatPatientDocumentDate(dateStr?: string | null): string {
  if (!dateStr) return '—';
  try {
    return new Date(dateStr).toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '—';
  }
}

/** Renderiza a 1ª página do PDF em JPEG pequeno (cache em memória). */
export async function renderPdfFirstPageThumbnail(
  url: string,
  maxWidth = 96,
): Promise<string | null> {
  if (thumbCache.has(url)) return thumbCache.get(url)!;

  try {
    const pdfjs = await import('pdfjs-dist');
    pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;

    const pdf = await pdfjs.getDocument({ url, withCredentials: false }).promise;
    const page = await pdf.getPage(1);
    const baseViewport = page.getViewport({ scale: 1 });
    const scale = Math.min(maxWidth / baseViewport.width, 1.5);
    const viewport = page.getViewport({ scale });

    const canvas = document.createElement('canvas');
    canvas.width = Math.floor(viewport.width);
    canvas.height = Math.floor(viewport.height);
    const ctx = canvas.getContext('2d');
    if (!ctx) return null;

    await page.render({ canvasContext: ctx, viewport }).promise;
    const dataUrl = canvas.toDataURL('image/jpeg', 0.75);
    thumbCache.set(url, dataUrl);
    return dataUrl;
  } catch {
    return null;
  }
}
